import {CameraComponent} from './Camera';

export default CameraComponent;
